var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDarkImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "uuid-892312d6-3f7c-4b65-b160-28eb5457ef52",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 85.39 64.04",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.01,64.04c-4.42,0-8.01-3.58-8.01-8.01V8.01C0,3.58,3.58,0,8.01,0H77.38c4.42,0,8.01,3.58,8.01,8.01V56.04c0,4.42-3.58,8.01-8.01,8.01H8.01Zm1.33-45.36c0,5.16,4.18,9.34,9.34,9.34s9.34-4.18,9.34-9.34-4.18-9.34-9.34-9.34-9.34,4.18-9.34,9.34ZM74.71,53.37v-18.68l-14.59-14.59c-.78-.78-2.05-.78-2.83,0l-22.6,22.6-9.26-9.26c-.78-.78-2.05-.78-2.83,0l-11.93,11.93v8.01H74.71Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDarkImage);
export default __webpack_public_path__ + "static/media/dark - image.154cd9acac1b15045c4ed4c1d95b6c0a.svg";
export { ForwardRef as ReactComponent };